export default __webpack_public_path__ + "static/media/jayakarta.d236542c.jpeg";